(ns ui.view.survey.modals.confirm-remove-column
  (:require
   [common.localization :as loc]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]
   [ui.components.modal.view :as modal]
   [ui.view.survey.modals.event :as event]
   [ui.view.survey.modals.sub :as sub]
   [ui.view.survey.sub :as survey-view-sub]))

(defn history-body
  [lang]
  [:div
   (loc/tr :you-are-about-to-delete-survey-row nil lang)])


(defn history-footer
  [lang]
  [:div
   {:class "flex flex-row flex-auto"}
   [:div
    {:class "flex flex-row justify-content-start"}
    [button/secondary-hollow
     {:on-click (fn [_]
                  (rf/dispatch [::event/close-remove-column-modal]))}
     (loc/tr :cancel nil lang)]]
   [:div
    {:class "flex flex-row flex-auto content-stretch justify-content-end"}
    [button/danger-solid
     {:on-click (fn [_]
                  (rf/dispatch [::event/delete-last-series]))}
     (loc/tr :delete-last-series-button nil lang)]]])

(defn view
  []
  (let [survey-id @(rf/subscribe [::sub/survey-id])
        lang @(rf/subscribe [::survey-view-sub/selected-lang survey-id])]
    [modal/view
     {:visible? @(rf/subscribe [::sub/remove-modal-open?])
      :hide!    #(rf/dispatch [::event/close-remove-column-modal])
      :size     :full}
     (loc/tr :survey-remove-modal-title nil lang)
     [history-body lang]
     [history-footer lang]]))
